/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'

type Props = {
  accion: string
}

const LogCeldaAccion: FC<Props> = ({ accion }) => (
  <div className='d-flex align-items-center'>
    {accion === 'Inicio de Sesión' ? (<div className='bg-primary text-white rounded-3 py-1 px-4' style={{ width: '130px', textAlign: 'center' }}>Inicio de Sesión</div>)
      : accion === 'borrar' ? (<div className='bg-danger text-white rounded-3 py-1 px-4' style={{ width: '130px', textAlign: 'center' }}> Borrar </div>)
        : accion === 'actualizar' ? (<div className='bg-warning text-white rounded-3 py-1 px-4' style={{ width: '130px', textAlign: 'center' }}> Actualizar</div>)
          : accion === 'crear' ? (<div className='bg-success text-white rounded-3 py-1 px-2' style={{ width: '130px', textAlign: 'center' }}> Crear</div>)
            : accion === 'cancelar' ? (<div className='bg-danger text-white rounded-3 py-1 px-4' style={{ width: '130px', textAlign: 'center' }}> Cancelar </div>)
              :
              (<div className='bg-danger text-white rounded-3 py-1 px-4'> Error</div>)}
  </div>
)

export { LogCeldaAccion }
